import * as $ from "jquery";
import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { CanvassStatus } from "../../models/canvass-status.model";
import { FieldDataProvider } from "../../data-provider/field.dp";
import { PermissionCheck } from "../../shared/permission";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { TalkingPointDataProvider } from "../../data-provider/talking-point.dp";
import { CanvassStatusDataProvider } from "../../data-provider/canvass-status.dp";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { Utils } from "../../helper/utils.helper";
import { Feature } from "../../models/feature.model";

let CustomizeComponent = {
    selector: "vcCustomize",
    templateUrl: "/angular/components/customize/customize.component.html",
    bindings: {},
    controller: class Customize {
        public __env: any;
        public isLeaderView: boolean;
        public loading: boolean;
        public showingPreview: boolean;
        public activeCampaign: Campaign;
        public tab: string;
        public reception;
        public receptionDisabled;
        public efforts;
        public effort: Effort;
        public consentSettings = null;
        public securitySettings = null;
        public canvassStatus;
        public featurePermissions;
        public tabNames;
        public tabDescriptions;
        public canvassStatuses;
        private fields;
        private hasCreateCustomFieldPermission = false;

        private readonly $scope: any;
        private readonly $location: any;
        private readonly $window: any;
        private readonly utils: Utils;
        private readonly modelsUtils: any;
        private readonly dialog: DialogUtils;
        private readonly toast: ToastUtils;
        private readonly screen: ScreenUtils;
        public readonly fieldDataProvider: FieldDataProvider;
        public readonly permissionProvider: PermissionCheck;
        public readonly navigationBarService: NavigationBarHelperService;
        public readonly effortDataProvider: EffortDataProvider;
        private readonly talkingPointDataProvider: TalkingPointDataProvider;
        private readonly canvassStatusDataProvider: CanvassStatusDataProvider;
        private readonly surveyDataProvider: SurveyDataProvider;

        constructor(
            $window: any,
            $scope: any,
            $location: any,
            __env: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ScreenUtils: ScreenUtils,
            CampaignDataProvider: CampaignDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            TalkingPointDataProvider: TalkingPointDataProvider,
            CanvassStatusDataProvider: CanvassStatusDataProvider,
            EffortDataProvider: EffortDataProvider,
            FieldDataProvider: FieldDataProvider,
            PermissionCheck: PermissionCheck,
            SurveyDataProvider: SurveyDataProvider,
            Utils: Utils,
            ModelsUtils: any
        ) {
            this.modelsUtils = ModelsUtils;
            this.utils = Utils;
            this.utils.accessCheck();
            this.utils.runWootric();
            this.__env = __env;
            this.isLeaderView = __app_type == "LEADER";
            this.loading = true;
            this.fieldDataProvider = FieldDataProvider;
            this.permissionProvider = PermissionCheck;
            this.showingPreview = false;
            this.navigationBarService = NavigationBarHelperService;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.screen = ScreenUtils;
            this.$window = $window;
            this.$location = $location;
            this.$scope = $scope;
            this.canvassStatusDataProvider = CanvassStatusDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.effort = new Effort();
            this.canvassStatus = new CanvassStatus();
            this.talkingPointDataProvider = TalkingPointDataProvider;
            this.surveyDataProvider = SurveyDataProvider;

            this.permissionProvider
                .getFeaturePermissions()
                .then((featurePermission) => {
                    this.featurePermissions = featurePermission;
                    this.reception = this.modelsUtils.feature(
                        this.featurePermissions.RECEPTION.attributes
                    );

                    if (this.isLeaderView) {
                        this.hasCreateCustomFieldPermission =
                            this.permissionProvider.hasPermission(
                                "CREATE_CUSTOM_FIELD_ORGANISATION_LEVEL"
                            );
                    } else {
                        this.hasCreateCustomFieldPermission =
                            this.permissionProvider.hasPermission(
                                "CREATE_CUSTOM_FIELD_CAMPAIGN_LEVEL"
                            );
                    }
                });

            this.tabNames = {
                fields: "Custom Fields",
                statuses: "Interaction Statuses",
                conversion: "Conversion Settings",
                features: "Permission Settings",
                efforts: "Campaign Efforts",
                surveys: "Surveys",
                rating: "Ratings",
                talkingpoints: "Talking Points",
                consent: "Consent Settings",
                signature: "Signature Settings",
                permissionlevels: "Permission Levels",
            };

            this.tabDescriptions = {
                fields: "Create custom fields and choose which fields appear on your interaction screen",
                statuses: "Add or change the statuses of your interactions",
                conversion:
                    "Define what counts as a conversion for your team. Choose which interaction outcomes are counted as successes, and which are counted as attempts.",
                features:
                    "Customize what features are accessible to which users",
                talkingpoints:
                    "Share key updates and messages with your field organizers. This information is accessible within the mobile app",
                rating: "Customize the description for each star rating, which will regulate how your organizers rate interactions",
                surveys: "Publish surveys to your organizers using drag & drop",
                efforts:
                    "Campaign efforts are your organization's way of engaging your community. You can tailor your campaigns " +
                    "to your specific needs so it is clear to team members what is required of them. Analytics data is effort specific, " +
                    "meaning this is an effective way to categorize your different forms of campaigning or contact.",
                consent:
                    "The options will appear anywhere you process and store personal data for contacts",
                signature:
                    "Customize all aspects surrounding collecting contacts' signatures",
                permissionlevels:
                    "Customise the display name and description for each permission level",
            };
        }

        $onInit() {
            let searchPath = this.$location.search();
            this.tab = searchPath.tab ? searchPath.tab : "fields";

            this.fieldDataProvider.getAllFields().then((fields) => {
                this.fields = fields;
                this.loading = false;
            });

            this.canvassStatusDataProvider
                .walkCanvassStatuses()
                .then((statuses) => {
                    this.canvassStatuses = statuses;
                });

            this.effortDataProvider.getAllEfforts().then((efforts) => {
                this.efforts = efforts;
            });

            this.permissionProvider
                .getConsentSettings()
                .then((consentSettings) => {
                    this.consentSettings = consentSettings;
                });

            this.permissionProvider
                .getSecuritySettings()
                .then((securitySettings) => {
                    this.securitySettings = securitySettings;
                });
        }

        changeTab(tab: string): void {
            // Don't set `this.tab` directly — let it follow the URL. If a
            // child tab vetoes the navigation via $locationChangeStart (e.g.
            // the conversion config's unsaved-changes prompt), `this.tab`
            // stays in sync with the URL that's actually committed instead
            // of drifting ahead and unmounting the active tab's component.
            this.$location.search("tab", tab);
        }

        isReceptionDisabled(feature): any {
            if (feature) {
                if (this.activeCampaign.oid) {
                    this.receptionDisabled =
                        !feature.owner &&
                        !feature.campaignmanager &&
                        !feature.campaignstaffer &&
                        !feature.canvasser &&
                        !feature.leadcanvasser &&
                        !feature.organisationleader &&
                        !feature.organisationowner &&
                        !feature.divisionmanager;
                }
                this.receptionDisabled =
                    !feature.owner &&
                    !feature.campaignmanager &&
                    !feature.campaignstaffer &&
                    !feature.canvasser &&
                    !feature.leadcanvasser;
            }
            return this.receptionDisabled;
        }

        openFeatureSettings(feature: Feature, $event): void {
            this.dialog
                .show({
                    preserveScope: true,
                    clickOutsideToClose: true,
                    component: "vc-feature-settings-dialog",
                    targetEvent: $event,
                    scope: this.$scope,
                    locals: {
                        feature: feature,
                    },
                    ariaLabel: "Feature Settings",
                })
                .then((featureUpdated) => {
                    feature.setData(featureUpdated);
                    this.permissionProvider.updateFeaturePermission(feature);
                });
        }

        setFeatureEnabled(feature: Feature, bool: boolean): void {
            feature.owner = bool;
            feature.campaignmanager = bool;
            feature.campaignstaffer = bool;
            feature.canvasser = bool;
            feature.leadcanvasser = bool;
            feature.organisationleader = bool;
            feature.organisationowner = bool;
            feature.divisionmanager = bool;

            feature.update().then(
                () => {},
                () => this.toast.error()
            );

            this.permissionProvider.updateFeaturePermission(feature);
        }

        openEffortDialog(ev: object): void {
            this.dialog.show({
                component: "vc-effort-form",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    effort: this.effort,
                    __env: this.__env,
                },
                size: "auto",
                ariaLabel: "Create Campaign Effort",
                ngClass:
                    "{'flex-100 flex-gt-xs-95 flex-gt-md-80 flex-gt-lg-70' : !$ctrl.effort.id, 'flex-100 flex-gt-xs-80 flex-gt-md-60 flex-gt-lg-40' : $ctrl.effort.id}",
                onComplete: (s, e) => {
                    $(e).find("input").first().focus();
                },
            });
        }

        openTalkingPointDialog(ev): void {
            this.dialog
                .show({
                    component: "vc-create-talking-point",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedPoint: null,
                        selectedCategory: null,
                        onlyTeam: false,
                    },
                })
                .then((pointEdited) => {
                    this.talkingPointDataProvider
                        .createPoint(pointEdited)
                        .then(() => {
                            this.toast.success("Point Created");
                        });
                });
        }

        openFieldDialog(ev): void {
            this.dialog.show({
                component: "vc-custom-field-form",
                targetEvent: ev,
                scope: this.$scope,
                size: "large",
                locals: {
                    bindedField: null,
                },
            });
        }

        openCanvassStatusDialog(ev): void {
            this.dialog.show({
                component: "vc-canvass-status-form",
                parent: angular.element(document.body),
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: false,
                ariaLabel: "Create Interaction Status",
                locals: {
                    selectedStatus: this.canvassStatus,
                },
            });
        }

        showConsentSettingsInfo($event): void {
            $event.stopPropagation();
            let openInfoModal = this.dialog
                .confirm()
                .htmlContent(
                    '<p style="max-width: 500px">' +
                        "Consent settings allow you to control your reasons for capturing consent. Consent is required of a " +
                        this.__env.strings.voter +
                        " when you wish to have ongoing contact with them.<br/><br/>" +
                        '<a href="' +
                        this.__env.gdpr_link +
                        '" class="md-primary" target="_blank">Learn more</a></p>'
                )
                .ok("OK");
            this.dialog.showPreConfiguredDialog(openInfoModal);
        }

        createSurveyDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: {},
                        teamOnly: false,
                    },
                })
                .then((survey: any) => {
                    this.surveyDataProvider.clearAll();
                    this.goToSurvey(survey);
                });
        }

        goToSurvey(survey): void {
            if (this.isLeaderView) {
                this.$window.location =
                    "./leader.php#/leader_survey/" + survey.sid;
            } else {
                this.$window.location = "./#/survey/" + survey.sid;
            }
        }
    },
};

angular
    .module("customize")
    .component(CustomizeComponent.selector, CustomizeComponent);
